import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';
import ModuleIntroPopUp from '../../body/ModuleIntroPopUp';

const Introduction = () => {
  return (
    <>
      <ModuleIntroPopUp
        moduleTitle={'Program Strategies Part 1 Module Tasks'}
        timeEstimate={'30 minutes'}
        listItems={[
          'Learn the Program Strategies',
          'Watch Videos',
          'Complete Activities',
          'Take a Quiz - 80% or higher required to move on',
        ]}
      />
      <VideoAndShowPDFAfter
        vidSrc={1194418595}
        pdfFile={pdfFiles.strategiesPart1[0]}
      />
    </>
  );
};

export default Introduction;
